require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');



//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.5.3@core-js/library/fn/is-iterable.js
// module id = 371
// module chunks = 0